<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import CustomList from "../../compositions/CustomList.vue";
import ModalDialog from "../../compositions/ModalDialog.vue";
import SelectBox from "../../compositions/SelectBox.vue";
import TextBox from "../../compositions/TextBox.vue";
import CheckBox from "../../compositions/CheckBox.vue";
import Chart from "../../compositions/Chart.vue";
import OrderHistoryMedicineComponent from "./OrderHistoryMedicineComponent.vue";
import config from "../../config.js";
import { errorAlert } from "../../plugins/alert";
import { getFieldValue } from "../../plugins/utility";
import qs from 'qs';
import axios from '../../plugins/axios.ts';
import moment from "moment";

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    searchKey:{
      type:[String,Number],
      default:() => {
        return '';
      },
    },
    searchKeyField:{
      type:String,
      default:() => {
        return 'yj_code';
      },
    },
});

const { searchKey } = toRefs(props);
const medicineHistoryFields = reactive([
  {field_name: '', field_key: 'summary_key', width: '15%', align: 'text-center'},
  {field_name: '処方', field_key: 'prescript_number', width: '10%', align: 'text-center'},
  {field_name: '棚卸差分', field_key: 'inventory_number', width: '10%', align: 'text-center'},
  {field_name: '卸', field_key: 'van_number', width: '10%', align: 'text-center'},
  {field_name: '小分け(販売)', field_key: 'pack_sell_number', width: '10%', align: 'text-center'},
  {field_name: '小分け(購入)', field_key: 'pack_buy_number', width: '10%', align: 'text-center'},
  {field_name: '在庫変動数', field_key: 'stock_change_number', width: '10%', align: 'text-center'},
]);
const dateList = reactive([]);
//今年からさかのぼって5年分表示する
let today = new Date();
for (let i=0;i<5*12;i++) {
  dateList.push({
    id:moment(today).format('YYYY/MM'),
    date:moment(today).format('YYYY/MM')
  });
  today = moment(today).subtract(1,'months');
}
const selectDate = ref(dateList[0]['id']);
const editSelectChange = (value) => {
  selectDate.value = value;
  getChartData();
}

const medicineHistoryOptionFields = reactive({page_size:20});
medicineHistoryOptionFields[props.searchKeyField] = props.searchKey;
const listMedicineHistoryRef = ref();
const chartData = reactive([]);
const medicineHistoryData = reactive([]);
const isMedicineDetailDialog = ref(false);
const isMedicineDetailLoading = ref(false);
const getChartData = async () => {
  try {
    let chartParams = {is_day:1,target_month:selectDate.value};
    chartParams[props.searchKeyField] = props.searchKey;
    const charParamsSerializer = (chartParams) => qs.stringify(chartParams);
    const responseChart = await axios.get(props.apis.pharmacy_order_history_summary_list,{params:chartParams,charParamsSerializer});
    let chartRecord = {};
    chartRecord.labels = [];
    chartRecord.datasets = [];
    let now = new Date(selectDate.value + '/01');
    let lastDay = moment(now).endOf('month');
    while (now <= lastDay) {
      chartRecord.labels.push(moment(now).format("YYYY/MM/DD"));
      now.setDate(now.getDate() + 1)
    }
    let inventory = [];
    let prescript = [];
    let pack_sell = [];
    let pack_buy = [];
    let van = [];
    let stock = [];
    let first = false;
    let stockNumber = 0;
    for (let dayIdx=0;dayIdx<chartRecord.labels.length;dayIdx++) {
      let exists = false;
      for (let i=0;i<responseChart.data.list.length;i++) {
        if (chartRecord.labels[dayIdx] == responseChart.data.list[i].summary_key) {
          exists = true;
          inventory.push(responseChart.data.list[i].inventory_number);
          prescript.push(responseChart.data.list[i].prescript_number);
          van.push(responseChart.data.list[i].van_number);
          pack_sell.push(responseChart.data.list[i].pack_sell_number);
          pack_buy.push(responseChart.data.list[i].pack_buy_number);
          stock.push(responseChart.data.list[i].stock_number);
          stockNumber = responseChart.data.list[i].stock_number;
          if (first == false) {
            //月の最初まで全て同じ値にする
            for (let j=dayIdx-1;j>=0;j--) {
              stock[j] = responseChart.data.list[i].first_stock_number;
            }
          }
          first = true;
          break;
        }
      }
      if (exists == false) {
        inventory.push(0);
        prescript.push(0);
        van.push(0);
        pack_sell.push(0);
        pack_buy.push(0);
        stock.push(stockNumber);
      }
    }
    chartRecord.datasets.push({
        type:'bar',
        label:'棚卸',
        backgroundColor:'#2dc181',
        data:inventory,
    });
    chartRecord.datasets.push({
        type:'bar',
        label:'処方',
        backgroundColor:'#f6b80d',
        data:prescript,
    });
    chartRecord.datasets.push({
        type:'bar',
        label:'卸',
        backgroundColor:'#4b0df6',
        data:van,
    });
    chartRecord.datasets.push({
        type:'bar',
        label:'小分け(販売)',
        backgroundColor:'#f62c0d',
        data:pack_sell,
    });
    chartRecord.datasets.push({
        type:'bar',
        label:'小分け(購入)',
        backgroundColor:'#c7f60d',
        data:pack_buy,
    });
    chartRecord.datasets.push({
        type:'line',
        label:'在庫数',
        backgroundColor:'#4142CC',
        data:stock,
    });
    chartData.splice(0);
    chartData.push(chartRecord);
  } finally {
    isMedicineDetailLoading.value = false;
  }
}
const getPharmacyStockDetail = async () => {
  medicineHistoryData.splice(0);
  if (!props.searchKey) {
    return;
  }
  isMedicineDetailLoading.value = true;
  let params = {};
  params[props.searchKeyField] = props.searchKey;
  const paramsSerializer = (params) => qs.stringify(params);
  try {
    const response = await axios.get(props.apis.pharmacy_medicine_stock_detail,{params:params,paramsSerializer});
    for (let i=0;i<response.data.data.length;i++) {
      medicineHistoryData.push(response.data.data[i]);
    }
  } finally {
    isMedicineDetailLoading.value = false;
  }
}
watch(searchKey,(newValue,oldValue) => {
  medicineHistoryOptionFields[props.searchKeyField] = newValue;
  getPharmacyStockDetail();
  getChartData();
  listMedicineHistoryRef.value.resetItem();
});
</script>

<style scoped>
</style>
<template>
<div>
  <div v-show="isMedicineDetailLoading" class="loading-mask">
    <div class="loading-content">
      <span style="color: white"><img src="../../../public/images/loading.gif"></span>
    </div>
  </div>
  <div v-for="medicineHistoryRecord in medicineHistoryData" :key="medicineHistoryRecord.id" class="border rounded">
    <div class="m-1 flex items-center justify-between">
      <div>{{ medicineHistoryRecord.medicine.product_name }}</div>
      <div>{{ medicineHistoryRecord.medicine.package_label }}</div>
      <div v-html="medicineHistoryRecord.medicine.warning_mark"></div>
    </div>
    <div class="m-1">実在庫：{{ medicineHistoryRecord.real_stock_number.toLocaleString() + medicineHistoryRecord.medicine.package_unit }}</div>
    <div :class="'m-1 ' + (medicineHistoryRecord.real_stock_number != medicineHistoryRecord.stock_number ? ' text-red-700' : '')">仮在庫：{{ medicineHistoryRecord.stock_number.toLocaleString() + medicineHistoryRecord.medicine.package_unit }}</div>
  </div>
  <div class="w-full mt-1 h-full" v-for="(chartDataRecord,index) in chartData" :key="index">
    <div class="font-bold">【在庫推移】</div>
    <div class="m-1">
      <select-box
        :value="selectDate"
        :options="dateList"
        list-field-name="date"
        :on-change="editSelectChange"
        :is-searchable="false"
        list-height="20em"
        place-holder=""
      ></select-box>
    </div>
    <div>
      <chart
        chart-type="bar"
        height="200px"
        :chart-data="chartDataRecord"
      ></chart>
    </div>
  </div>
  <div>
    <custom-list
      ref="listMedicineHistoryRef"
      :table-fields="medicineHistoryFields"
      :option-fields="medicineHistoryOptionFields"
      :api-url="apis.pharmacy_order_history_summary_list"
      height="40vh"
    >
      <template v-slot:item="slotProps">
        <td v-for="(field,index) in medicineHistoryFields" :key="index" :style="'width:' + field.width" class="text-center">
          <div v-if="field.field_key == 'summary_key'">
            {{ slotProps.item.summary_key }}
          </div>
          <div v-else :class="field.align">
            {{ slotProps.item[field.field_key].toLocaleString() }}{{ slotProps.item.package_unit }}
          </div>
        </td>
      </template>
    </custom-list>
  </div>
</div>
</template>

